// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bulk-selection-item-details {
  align-items: center;
  bottom: 4px;
  color: #fff;
  display: flex;
  left: 4px;
}
.bulk-selection-item-details svg {
  height: 16px;
  vertical-align: sub;
  width: 16px;
}
.bulk-selection-item-details .item-details-info {
  float: left;
}
.bulk-selection-item-details .item-details-info .bulk-uia-rights-icons {
  font-size: 16px;
}
.bulk-selection-item-details .item-details-info .bulk-uia-rights-icons .bulk-uia-rights-approved {
  color: #00814b;
}
.bulk-selection-item-details .item-details-info .bulk-uia-rights-icons .bulk-uia-rights-pending {
  color: #ffd641;
}
.bulk-selection-item-details .item-details-info .bulk-uia-rights-icons .bulk-uia-rights-rejected {
  color: #cc3b26;
}
.bulk-selection-item-details .item-details-info .svg-icon-products-icon .svg-fill-color-1 {
  fill: #fff;
}
.bulk-selection-item-details .item-details-info .svg-icon-products-icon .svg-fill-color-2 {
  fill: #fff;
}
.bulk-selection-item-details .item-details-info .svg-icon-distribute-icon .svg-fill-color-1 {
  fill: #fff;
}
.bulk-selection-item-details .item-details-info .svg-icon-distribute-icon .svg-fill-color-2 {
  fill: #fff;
}
`, "",{"version":3,"sources":["webpack://./app/bulk-actions/bulk-selection-item-details/bulk-selection-item-details.less"],"names":[],"mappings":"AAMA;EACI,mBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;AALJ;AAAA;EAQQ,YAAA;EACA,mBAAA;EACA,WAAA;AALR;AALA;EAcQ,WAAA;AANR;AARA;EAiBY,eAAA;AANZ;AAXA;EAoBgB,cAAA;AANhB;AAdA;EAwBgB,cAAA;AAPhB;AAjBA;EA4BgB,cAAA;AARhB;AApBA;EAkCgB,UAAA;AAXhB;AAvBA;EAqCgB,UAAA;AAXhB;AA1BA;EA2CgB,UAAA;AAdhB;AA7BA;EA8CgB,UAAA;AAdhB","sourcesContent":["//\n// Copyright (c) 2011-2018 by Curalate, Inc.\n//\n\n@import (reference) '../../../css/unison';\n\n.bulk-selection-item-details {\n    align-items: center;\n    bottom: 4px;\n    color: @cu-white;\n    display: flex;\n    left: 4px;\n\n    svg {\n        height: 16px;\n        vertical-align: sub;\n        width: 16px;\n    }\n\n    .item-details-info {\n        float: left;\n\n        .bulk-uia-rights-icons {\n            font-size: 16px;\n\n            .bulk-uia-rights-approved {\n                color: @cu-color-success;\n            }\n\n            .bulk-uia-rights-pending {\n                color: @cu-yellow-2;\n            }\n\n            .bulk-uia-rights-rejected {\n                color: @cu-color-error;\n            }\n        }\n\n        .svg-icon-products-icon {\n            .svg-fill-color-1 {\n                fill: @cu-white;\n            }\n            .svg-fill-color-2 {\n                fill: @cu-white;\n            }\n        }\n\n        .svg-icon-distribute-icon {\n            .svg-fill-color-1 {\n                fill: @cu-white;\n            }\n            .svg-fill-color-2 {\n                fill: @cu-white;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
